'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { AsyncStaticPriceText } from '@udemy-v2/react-course-pricing';
import { useClpCourse } from '@/features/course-landing-page/context/clp-course-provider.react-component';
import { useClpPurchaseContext } from '@/features/course-landing-page/context/clp-purchase-context.react-component';
import { ClpPrimaryCtaButton } from '@/features/course-landing-page/components/clp-primary-cta-button/clp-primary-cta-button.react-component';
import styles from './enrollment-sticky-footer-content.module.scss';

/**
 * EnrollmentStickyFooterContent component displays price and CTA button for enrollment.
 * Conditionally hides price for courses included in subscription and shows 'Free' for free courses.
 * Renders when the course is free or included in subscription and the user is not already enrolled.
 */
export const EnrollmentStickyFooterContent: React.FC = () => {
  const $ = _c(6);
  const {
    id: courseId
  } = useClpCourse();
  const {
    isCourseIncludedInUserSubscription
  } = useClpPurchaseContext();
  let t0;
  if ($[0] !== courseId || $[1] !== isCourseIncludedInUserSubscription) {
    t0 = !isCourseIncludedInUserSubscription && <AsyncStaticPriceText listPriceClassName="ud-heading-lg" courseId={Number(courseId)} />;
    $[0] = courseId;
    $[1] = isCourseIncludedInUserSubscription;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ClpPrimaryCtaButton className={styles["enroll-now-cta-button"]} udStyle="primary" />;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0) {
    t2 = <div className={styles.container}>{t0}{t1}</div>;
    $[4] = t0;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};